import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
    readonly width?: string;
    readonly height?: string;
}

const OpenFolderIcon: React.FC<IconProps> = ({ ...props }) => (
    <svg
        width='161'
        height='161'
        viewBox='0 0 161 161'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...props}
    >
        <g id='folder_open'>
            <mask
                id='mask0_1129_53751'
                type='alpha'
                maskUnits='userSpaceOnUse'
                x='0'
                y='0'
                width='161'
                height='161'
            >
                <rect id='Bounding box' width='160.562' height='160.562' fill='#D9D9D9' />
            </mask>
            <g mask='url(#mask0_1129_53751)'>
                <path
                    id='folder_open_2'
                    d='M24.0351 132.492C21.213 132.492 18.8353 131.423 16.9018 129.285C14.9673 127.149 14 124.522 14 121.403V40.9422C14 37.8239 15.0955 35.0537 17.2865 32.6315C19.4786 30.2105 21.9857 29 24.8078 29H58.1294L71.5096 43.7845H123.614C125.922 43.7845 127.935 44.4739 129.655 45.8525C131.374 47.2312 132.577 49.0059 133.264 51.1768H68.8201L55.44 36.3923H24.8078C23.6069 36.3923 22.6202 36.8186 21.8475 37.6711C21.0759 38.5249 20.6901 39.6153 20.6901 40.9422V120.55C20.6901 121.593 20.9259 122.446 21.3975 123.109C21.8692 123.773 22.4908 124.342 23.2624 124.815L38.4188 68.8037H146.902L131.732 124.66C131.097 127.009 129.882 128.902 128.086 130.339C126.288 131.774 124.283 132.492 122.07 132.492H24.0351ZM30.2368 125.099H124.644L137.843 76.1959H43.4363L30.2368 125.099Z'
                    fill='#ECDCFF'
                />
            </g>
        </g>
    </svg>
);

export { OpenFolderIcon };
